export default {
  en: {
    addWorkSchedule: "Add Work Schedule",
    import: "Import",
    importSchedules: "Import Schedules",
    importWeekOff: "Import Week Off",
    importWorkSchedules: "Import Work Schedules",
    updateWorkSchedules: "Update Work Schedules",
    updateWeekOff: "Update Week Off",
    noWorkScheduleExist: "No work schedule exist.",
    workScheduleAddedSuccess:
      "Work schedule and week off details added successfully!",
    lateAttendancePolicyNote:
      "Your current settings have the late attendance policy activated for select work schedules. If you plan to apply this policy to a newly established work schedule, please proceed by clicking this link.",
    technicalDifficultiesFetchingWorkSchedule:
      "It's us! There seems to be some technical difficulties while fetching the work schedule details. Please try after some time.",
    somethingWentWrongFetchingWorkSchedule:
      "Something went wrong while fetching the work schedule details. If you continue to see this issue, please contact the platform administrator.",
    noAccessView:
      "Sorry, you don't have access to view work schedule & week off details. Please contact HR administrator.",
    workScheduleNotExist:
      "Work schedule does not exist as the record is already deleted in the same or some other user session.",
    somethingWentWrongRetrieving:
      "Something went wrong while retrieving work schedule & week off details. Please try after some time.",
    someTechDifficulties:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    workScheduleTitle: "Work Schedule",
    workScheduleCode: "Work Schedule Code",
    organizationGroupTitle: "Organization Group",
    coreHrLoadingError:
      "Something went wrong while loading the core hr forms. Please try after some time.",
    weekOffDays: "Days",
    weekOffAll: "All",
    weekOffFirst: "1st",
    weekOffSecond: "2nd",
    weekOffThird: "3rd",
    weekOffFourth: "4th",
    weekOffFifth: "5th",
    weekOffExcludeLastWeek: "Exclude Last Week of the Month",
    weekOffFullDay: "Full Day",
    weekOffHalfDay: "Half Day",
    weekOffWeekOff: "Week Off",
    weekOffMonday: "Monday",
    weekOffTuesday: "Tuesday",
    weekOffWednesday: "Wednesday",
    weekOffThursday: "Thursday",
    weekOffFriday: "Friday",
    weekOffSaturday: "Saturday",
    weekOffSunday: "Sunday",
    weekOffYes: "Yes",
    weekOffNo: "No",
    viewWorkScheduleEdit: "Edit",
    viewWorkScheduleSchedule: "Schedule",
    viewWorkScheduleWeekOff: "Week Off",
    viewWorkScheduleWorkScheduleCode: "Work Schedule Code",
    viewWorkScheduleWorkSchedule: "Work Schedule",
    viewWorkScheduleOverlappingDays: "Overlapping Days",
    viewWorkScheduleBusinessHours: "Business Hours",
    viewWorkSchedulePerSchedule: "per schedule",
    viewWorkScheduleBreakSchedule: "Break Schedule",
    viewWorkScheduleShiftMargin: "Shift Margin",
    viewWorkScheduleHours: "hours",
    viewWorkScheduleMinutes: "minutes",
    viewWorkScheduleBeforeShiftStarts: "before the shift starts",
    viewWorkScheduleAfterShiftEnds: "after the shift ends",
    viewWorkScheduleTimezone: "Timezone",
    viewWorkScheduleTargetEffort: "Target Effort In Hours(Per Week)",
    viewWorkScheduleRegularHours: "Regular Hours(Per Day)",
    viewWorkScheduleOvertimeHours: "Overtime Hours(Per Day)",
    viewWorkScheduleOvertimeThresholdHours: "Overtime Threshold Hours",
    viewWorkScheduleStatus: "Status",
    viewWorkScheduleAdditionalSettings: "Additional Settings",
    viewWorkScheduleOvertimeCoolingPeriod: "Overtime Cooling Period",
    viewWorkScheduleAllowAttendanceOutside:
      "Allow Attendance Outside Regular Work Hours",
    viewWorkScheduleEarlyCheckInOverride: "Early Check-In Override",
    viewWorkScheduleEnableGraceTime: "Enable Grace Time",
    viewWorkScheduleGracePeriodCheckIn: "Grace Period For Check-In",
    viewWorkScheduleCheckOutBufferTime: "Check-Out Buffer Time",
    viewWorkScheduleDescription: "Description",
    viewWorkScheduleNext: "Next",
    viewWorkScheduleYes: "Yes",
    viewWorkScheduleNo: "No",
    noResults: "No matching search results found.",
    businessHours: "Business Hours",
    breakSchedule: "Break Schedule",
    targetEffortPerWeek: "Target Effort Per Week",
    status: "Status",
    delete: "Delete",
    hours: "Hours",
    active: "Active",
    inActive: "InActive",
    added: "Added",
    updated: "Updated",
    deleteConfirmation: "Are you sure to delete the work schedule?",
    cancel: "Cancel",
    proceed: "Proceed",
    excludeEmployees: "Exclude Employees",
    includeEmployees: "Include Employees",
    deleteSuccess: "Work schedule deleted successfully.",
    noDeleteAccess: "Sorry, you don't have access to delete work schedule.",
    deleteError:
      "Something went wrong while deleting the work schedule. Please try after some time.",
    deleteErrorTechnical:
      "It's us! There seems to be some technical difficulties while deleting the work schedule. Please try after some time.",
    deleteErrorNoAccess:
      "Sorry, you don't have access to delete the work schedule. Please contact HR administrator.",
    deleteErrorInUse:
      "Unable to delete the record as it was opened in the same or some other user session.",
    deleteErrorAttendance:
      "Unable to delete the record as the work schedule is associated with the attendance settings.",
    deleteErrorAdmin:
      "Something went wrong while deleting the work schedule. If you continue to see this issue, please contact the platform administrator.",
    editWorkScheduleSchedule: "Schedule",
    editWorkScheduleWeekOff: "Week Off",
    editWorkScheduleSave: "Save",
    editWorkScheduleSaveAndNext: "Save & Next",
    editWorkScheduleExitConfirmation: "Are you sure to exit this form?",
    editWorkScheduleUpdateSuccess:
      "Work schedule details are updated successfully.",
    editWorkScheduleWeekOffUpdateSuccess:
      "Week off details are updated successfully.",
    editWorkScheduleTechnicalError:
      "It's us! There seem to be some technical difficulties. Please try after some time.",
    editWorkScheduleNoUpdateAccess:
      "Sorry, you don't have access rights to update work schedule details.",
    editWorkScheduleUpdateError:
      "Something went wrong while updating work schedule details. Please try after some time.",
    editWorkScheduleUpdateErrorAdmin:
      "Something went wrong while updating work schedule details. If you continue to see this issue, please contact the platform administrator.",
    editWorkScheduleShiftMarginEndTime:
      "Shift margin end time should be greater than the shift margin start time.",
    editWorkScheduleShiftMargin24Hours:
      "Shift margin start time and the shift margin end time should not exceed 24 hours.",
    editWorkScheduleAttendanceExists:
      "Work schedule cannot be updated as the attendance exists for the employees who are associated with this work schedule.",
    editWorkScheduleShiftScheduled:
      "Work schedule cannot be updated as the shift is scheduled for the shift-type associated with this work schedule.",
    editWorkScheduleNoWeekOffAccess:
      "Sorry, you don't have access rights to add week off details.",
    editWorkScheduleWeekOffUpdateError:
      "Something went wrong while updating week off details. Please try after some time.",
    editWorkScheduleWeekOffUpdateErrorAdmin:
      "Something went wrong while updating week off details. If you continue to see this issue, please contact the platform administrator.",
    editWorkScheduleWeekOffAttendanceExists:
      "Unable to update the week off details as the attendance exists for the employee who is associated with this work schedule",
    editWorkScheduleWeekOffShiftScheduled:
      "Unable to update the week off details as the shift is scheduled for the shift-type associated with this work schedule.",
    addWorkScheduleNew: "New",
    addWorkScheduleAddSuccess: "Work schedule details are added successfully.",
    addWorkScheduleWeekOffUpdateSuccess:
      "Week off details are updated successfully.",
    addWorkScheduleTechnicalError:
      "It's us! There seem to be some technical difficulties. Please try after some time.",
    addWorkScheduleNoAddAccess:
      "Sorry, you don't have access rights to add work schedule details.",
    addWorkScheduleAddError:
      "Something went wrong while adding work schedule details. Please try after some time.",
    addWorkScheduleAddErrorAdmin:
      "Something went wrong while adding work schedule details. If you continue to see this issue, please contact the platform administrator.",
    addWorkScheduleShiftMarginEndTime:
      "Shift margin end time should be greater than the shift margin start time.",
    addWorkScheduleShiftMargin24Hours:
      "Shift margin start time and the shift margin end time should not exceed 24 hours.",
    addWorkScheduleAttendanceExists:
      "Work schedule cannot be updated as the attendance exists for the employees who are associated with this work schedule.",
    addWorkScheduleShiftScheduled:
      "Work schedule cannot be updated as the shift is scheduled for the shift-type associated with this work schedule.",
    addWorkScheduleNoWeekOffAccess:
      "Sorry, you don't have access rights to add week off details.",
    addWorkScheduleWeekOffAddError:
      "Something went wrong while adding week off details. Please try after some time.",
    addWorkScheduleWeekOffAddErrorAdmin:
      "Something went wrong while adding week off details. If you continue to see this issue, please contact the platform administrator.",
    addWorkScheduleWeekOffAttendanceExists:
      "Unable to add the week off details as the attendance exists for the employee who is associated with this work schedule",
    addWorkScheduleWeekOffShiftScheduled:
      "Unable to update the week off details as the shift is scheduled for the shift-type associated with this work schedule.",
    addEditWorkScheduleTitle: "Work Schedule",
    addEditWorkScheduleOverlappingDays: "Overlapping Days",
    addEditWorkScheduleOverlappingDaysTooltip:
      "Enabling this flag will overlap two days i.e (21:00  to 4:00). And this can be enabled in the case of night shifts.",
    addEditWorkScheduleBusinessHours: "Business Hours",
    addEditWorkScheduleCheckIn: "Check-In",
    addEditWorkScheduleCheckOut: "Check-Out",
    addEditWorkSchedulePerSchedule: "per schedule",
    addEditWorkScheduleBreakSchedule: "Break Schedule",
    addEditWorkScheduleStartTime: "Start Time",
    addEditWorkScheduleEndTime: "End Time",
    addEditWorkScheduleShiftMargin: "Shift Margin",
    addEditWorkScheduleBeforeShiftStarts: "before the shift starts",
    addEditWorkScheduleAfterShiftEnds: "after the shift ends",
    addEditWorkScheduleHours: "hours",
    addEditWorkScheduleMinutes: "minutes",
    addEditWorkSchedulePayableHoursNote:
      "Check-in/check-out entries only within {start} to {end} considered as payable hours.",
    addEditWorkScheduleTimezone: "Timezone",
    addEditWorkScheduleTargetEffort: "Target Effort In Hours(Per Week)",
    addEditWorkScheduleRegularHours: "Regular Hours(Per Day)",
    addEditWorkScheduleOvertimeHours: "Overtime Hours(Per Day)",
    addEditWorkScheduleStatus: "Status",
    addEditWorkScheduleAdditionalSettings: "Additional Settings",
    addEditWorkScheduleOvertimeCoolingPeriod: "Overtime Cooling Period",
    addEditWorkScheduleOvertimeCoolingPeriodTooltip:
      "Overtime hours start after this period",
    addEditWorkScheduleAllowAttendanceOutside:
      "Allow Attendance Outside Regular Work Hours",
    addEditWorkScheduleAllowAttendanceOutsideTooltip:
      "Enabling this flag will allow the user to add the attendance outside the regular work hours but inside the shift margin.",
    addEditWorkScheduleEarlyCheckInOverride: "Early Check-In Override",
    addEditWorkScheduleEarlyCheckInOverrideTooltip:
      "Enabling this flag will consider the work schedule start time even if the employee has reported early.",
    addEditWorkScheduleEnableGraceTime: "Enable Grace Time",
    addEditWorkScheduleEnableGraceTimeTooltip:
      "Enabling this flag will allow the employees to adjust their check-in time based on the configured duration against the work schedule timing.",
    addEditWorkScheduleGracePeriod: "Grace Period For Check-In",
    addEditWorkScheduleCheckOutBufferTime: "Check-Out Buffer Time",
    addEditWorkScheduleCheckOutBufferTimeTooltip:
      "If checkout time exceeds(Work Hours To + Check Out Buffer Time), then work schedule check out is considered for check out attendance.",
    addEditWorkScheduleDescription: "Description",
    addEditWorkScheduleShiftMarginError:
      "Please adjust the shift margin hours to ensure that the total duration including shift margin is 24 hours",
    addEditWorkScheduleActive: "Active",
    addEditWorkScheduleInActive: "InActive",
    employeeType: "Employee Type",
    grades: "Grades",
    locations: "Locations",
    departmentHierarchy: "Department Hierarchy",
    designationsPositions: "Designations/Positions",
    jobRoles: "Job Roles",
    workSchedule: "Work Schedule",
    businessUnitCostCenter: "Business Unit / Cost Center",
    organizationGroup: "Organization Group",
    locationType: "Location Type",
    locationArea: "Location Area",
    jobLevels: "Job Levels",
    positionDetails: "Position Details",
    brand: "Brand",
    client: "Client",
    errorLoadingForms:
      "Something went wrong while loading the core hr forms. Please try after some time.",
    userAccounts: "User Accounts",
    customGroup: "Custom Group",
    projects: "Projects",
    holidays: "Holidays",
    documentSubtype: "Document Subtype",
    accreditationCategoryAndType: "Accreditation Category and Type",
    registerFace: "Register Face",
    customGroupLoadingError:
      "Something went wrong while loading the group form. Please try after some time.",
    customGroupNoRecords: "No records found",
    customGroupAddGroup: "Add Group",
    customGroupViewDeleted:
      "Unable to retrieve the custom group details as it was deleted in same or some other user session.",
    customGroupUpdateDeleted:
      "Unable to update the custom group as it was deleted already in same or some other user session.",
    customGroupDeleteDeleted:
      "Unable to delete the custom group as it was deleted already in same or some other user session.",
    customGroupTechnicalError:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    customGroupRetrieveError:
      "Something went wrong while retrieving the custom groups. Please try after some time.",
    customGroupFetchErrorAdmin:
      "Something went wrong while fetching the custom groups. If you continue to see this issue, please contact the platform administrator.",
    customGroupFetchError:
      "Something went wrong while fetching the custom groups. Please try after some time.",
    customGroupRetrieveErrorFilters:
      "Something went wrong while retrieving custom group filters. Please try after some time.",
    customGroupAddAccessDenied:
      "Sorry, you don't have access rights to create custom groups.",
    customGroupEdit: "Edit",
    customGroupNew: "New",
    customGroupSave: "Save",
    customGroupNoChanges: "There are no changes to be updated",
    customGroupLabel: "Custom Group",
    customGroupConfigureFor: "Configure For",
    customGroupEmployees: "Employees",
    customGroupRules: "Rules",
    customGroupDescription: "Description",
    customGroupBack: "Back",
    customGroupSelect: "Select",
    customGroupAdd: "Add",
    customGroupNoEmployees: "There are no employees to list",
    customGroupEmployeesRequired: "Employees are required",
    customGroupAddSuccess: "Custom group added successfully.",
    customGroupUpdateSuccess: "Custom group updated successfully.",
    customGroupUpdateWithEmployeesSuccess:
      "Custom group updated and additional employees are added successfully",
    customGroupExitConfirmation: "Are you sure to exit this form?",
    customGroupUpdateAccessDenied:
      "Sorry, you don't have rights to update custom groups.",
    customGroupNoRecordExist: "No records found",
    customGroupValidationError:
      "Something went wrong while validating the inputs when updating the custom group. Please try after some time",
    customGroupUpdateSuccessWithLeaveError:
      "Custom group updated successfully. But unable to update the leave balance. Please contact system administrator.",
    customGroupUpdateError:
      "Something went wrong while processing the request to update the custom group. Please try after some time.",
    customGroupUpdateErrorAdmin:
      "Something went wrong while updating the custom group. If you continue to see this issue, please contact the platform administrator.",
    customGroupCreateError:
      "Something went wrong while creating the custom group. Please try after some time.",
    customGroupCreateErrorAdmin:
      "Something went wrong while creating the custom group. If you continue to see this issue, please contact the platform administrator.",
    customGroupCreateErrorProcessing:
      "Something went wrong while processing the request to create the custom group. Please try after some time.",
    noEmployeesMatchFilter: "No employees match your filter rules",
    startAddingEmployees: "Start adding employees to this group",
    noEmployeesExcluded: "No employees are excluded from this group",
    tryChanging: "Do you want to try changing it?",
    search: "Search",
    employeeId: "Employee Id",
    employeeName: "Employee Name",
    designation: "Designation",
    department: "Department",
    action: "Action",
    remove: "Remove",
    include: "Include",
    exclude: "Exclude",
    noEmployeesToList: "There are no employees to list.",
    noEmployeesMatchSearch: "No employees match your search",
    selectAll: "Select All",
    includeConfirmation: "Are you sure you want to include the employee?",
    removeConfirmation: "Are you sure you want to remove the employee?",
    excludeConfirmation: "Are you sure you want to exclude the employee?",
    addNew: "Add New",
    sorryCouldntFind: "Sorry! Couldn't find a group that you searched.",
    configurationExist: "Configuration Exist",
    rule: "Rule",
    employees: "Employees",
    additionalEmployees: "Additional Employees",
    employeeExclusion: "Employee Exclusion",
    inclusionsExclusions: "Inclusions & Exclusions",
    view: "View",
    export: "Export",
    noDeleteAccessCustomGroup:
      "Sorry, you don't have access to delete the custom group.",
    configurationExists:
      "Custom group is already used for defining the business rules, and hence deletion is not allowed. You can create a new custom group, and configure them.",
    deleteConfirmationCustomGroup: "Are you sure you want to delete?",
    noEmployeesToListInclude:
      "There are no employees to list for including additional employees",
    noEmployeesToListExclude:
      "There are no employees to list for excluding the employees",
    retrieveError:
      "Something went wrong while retrieving employees. Please try after some time.",
    employeesExcluded: "Employee(s) excluded successfully",
    employeesIncluded: "Employee(s) included successfully",
    deleteSuccessCustomGroup: "Custom group was deleted successfully.",
    technicalDifficulties:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    noDeleteAccessHR:
      "Sorry, you don't have access to delete the custom group. Please contact HR administrator.",
    groupAssociated:
      "Unable to delete the custom group as it was associated with other forms.",
    deleteErrorCustomGroup:
      "Something went wrong while processing the request to delete the custom group. Please try after some time.",
    deleteErrorAdminCustomGroup:
      "Something went wrong while deleting the custom group. If you continue to see this issue, please contact the platform administrator.",
    edit: "Edit",
    back: "Back",
    addRule: "Add Rule",
    configuredFor: "Configured For",
    moreDetails: "More Details",
    changeFilter: "Change Filter",
    add: "Add",
    exitConfirmation: "Are you sure to exit this form?",
    employeesRemoved: "Employee(s) removed successfully",
    noFormAccess:
      "Sorry, you don't have access to view custom group details. Please contact HR administrator.",
    noRecordExist: "No records found",
    retrieveErrorAdmin:
      "Something went wrong while retrieving the custom group details. If you continue to see this issue, please contact the platform administrator.",
  },
  sp: {
    addWorkSchedule: "Agregar Horario de Trabajo",
    import: "Importar",
    importSchedules: "Importar Horarios",
    importWeekOff: "Importar Días Libres",
    importWorkSchedules: "Importar Horarios de Trabajo",
    updateWorkSchedules: "Actualizar Horarios de Trabajo",
    updateWeekOff: "Actualizar Días Libres",
    noWorkScheduleExist: "No existe horario de trabajo.",
    workScheduleAddedSuccess:
      "Horario de trabajo y detalles de días festivos agregados exitosamente!",
    lateAttendancePolicyNote:
      "Sus ajustes actuales tienen habilitada la política de asistencia tardía para los horarios de trabajo seleccionados. Si planea aplicar esta política a un nuevo horario de trabajo establecido, proceda haciendo clic en este enlace.",
    technicalDifficultiesFetchingWorkSchedule:
      "Es nosotros! Parece que hay algún problema técnico al obtener los detalles del horario de trabajo. Por favor, inténtalo de nuevo más tarde.",
    somethingWentWrongFetchingWorkSchedule:
      "Algo salió mal al obtener los detalles del horario de trabajo. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    noAccessView:
      "Lo sentimos, no tienes acceso para ver los detalles del horario de trabajo y los días festivos. Por favor, contacta al administrador de Recursos Humanos.",
    workScheduleNotExist:
      "El horario de trabajo no existe porque el registro ya ha sido eliminado en la misma o en otra sesión de usuario.",
    somethingWentWrongRetrieving:
      "Algo salió mal al obtener los detalles del horario de trabajo y los días festivos. Por favor, inténtalo de nuevo más tarde.",
    someTechDifficulties:
      "Es nosotros! Parece que hay algún problema técnico. Por favor, inténtalo de nuevo más tarde.",
    workScheduleTitle: "Horario de Trabajo",
    workScheduleCode: "Código de Horario de Trabajo",
    organizationGroupTitle: "Grupo de Organización",
    coreHrLoadingError:
      "Algo salió mal al cargar los formularios de recursos humanos. Por favor, inténtalo de nuevo más tarde.",
    weekOffDays: "Días",
    weekOffAll: "Todos",
    weekOffFirst: "1º",
    weekOffSecond: "2º",
    weekOffThird: "3º",
    weekOffFourth: "4º",
    weekOffFifth: "5º",
    weekOffExcludeLastWeek: "Excluir Última Semana del Mes",
    weekOffFullDay: "Día Completo",
    weekOffHalfDay: "Medio Día",
    weekOffWeekOff: "Día Libre",
    weekOffMonday: "Lunes",
    weekOffTuesday: "Martes",
    weekOffWednesday: "Miércoles",
    weekOffThursday: "Jueves",
    weekOffFriday: "Viernes",
    weekOffSaturday: "Sábado",
    weekOffSunday: "Domingo",
    weekOffYes: "Sí",
    weekOffNo: "No",
    viewWorkScheduleEdit: "Editar",
    viewWorkScheduleSchedule: "Horario",
    viewWorkScheduleWeekOff: "Día Libre",
    viewWorkScheduleWorkScheduleCode: "Código de Horario de Trabajo",
    viewWorkScheduleWorkSchedule: "Horario de Trabajo",
    viewWorkScheduleOverlappingDays: "Días Superpuestos",
    viewWorkScheduleBusinessHours: "Horario Comercial",
    viewWorkSchedulePerSchedule: "por horario",
    viewWorkScheduleBreakSchedule: "Horario de Descanso",
    viewWorkScheduleShiftMargin: "Margen de Turno",
    viewWorkScheduleHours: "horas",
    viewWorkScheduleMinutes: "minutos",
    viewWorkScheduleBeforeShiftStarts: "antes de que comience el turno",
    viewWorkScheduleAfterShiftEnds: "después de que termine el turno",
    viewWorkScheduleTimezone: "Zona Horaria",
    viewWorkScheduleTargetEffort: "Esfuerzo Objetivo en Horas (Por Semana)",
    viewWorkScheduleRegularHours: "Horas Regulares (Por Día)",
    viewWorkScheduleOvertimeHours: "Horas Extra (Por Día)",
    viewWorkScheduleOvertimeThresholdHours: "Horas límite de horas extra",
    viewWorkScheduleStatus: "Estado",
    viewWorkScheduleAdditionalSettings: "Configuraciones Adicionales",
    viewWorkScheduleOvertimeCoolingPeriod:
      "Período de Enfriamiento de Horas Extra",
    viewWorkScheduleAllowAttendanceOutside:
      "Permitir Asistencia Fuera del Horario Regular",
    viewWorkScheduleEarlyCheckInOverride: "Anulación de Entrada Temprana",
    viewWorkScheduleEnableGraceTime: "Habilitar Tiempo de Gracia",
    viewWorkScheduleGracePeriodCheckIn: "Período de Gracia para Entrada",
    viewWorkScheduleCheckOutBufferTime: "Tiempo de Búfer de Salida",
    viewWorkScheduleDescription: "Descripción",
    viewWorkScheduleNext: "Siguiente",
    viewWorkScheduleYes: "Sí",
    viewWorkScheduleNo: "No",
    noResults: "No se encontraron resultados de búsqueda coincidentes.",
    workSchedule: "Horario de Trabajo",
    businessHours: "Horario Comercial",
    breakSchedule: "Horario de Descanso",
    targetEffortPerWeek: "Esfuerzo Objetivo por Semana",
    status: "Estado",
    delete: "Eliminar",
    hours: "Horas",
    active: "Activo",
    inActive: "Inactivo",
    added: "Agregado",
    updated: "Actualizado",
    deleteConfirmation: "¿Está seguro de eliminar el horario de trabajo?",
    cancel: "cancelar",
    proceed: "Proceder",
    excludeEmployees: "Excluir Empleados",
    includeEmployees: "Incluir Empleados",
    deleteSuccess: "Horario de trabajo eliminado exitosamente.",
    noDeleteAccess:
      "Lo sentimos, no tienes acceso para eliminar el horario de trabajo.",
    deleteError:
      "Algo salió mal al eliminar el horario de trabajo. Por favor, inténtalo de nuevo más tarde.",
    deleteErrorTechnical:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al eliminar el horario de trabajo. Por favor, inténtalo de nuevo más tarde.",
    deleteErrorNoAccess:
      "Lo sentimos, no tienes acceso para eliminar el horario de trabajo. Por favor, contacta al administrador de Recursos Humanos.",
    deleteErrorInUse:
      "No se puede eliminar el registro porque está abierto en la misma u otra sesión de usuario.",
    deleteErrorAttendance:
      "No se puede eliminar el registro porque el horario de trabajo está asociado con la configuración de asistencia.",
    deleteErrorAdmin:
      "Algo salió mal al eliminar el horario de trabajo. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    editWorkScheduleSchedule: "Horario",
    editWorkScheduleWeekOff: "Día Libre",
    editWorkScheduleSave: "Guardar",
    editWorkScheduleSaveAndNext: "Guardar y Siguiente",
    editWorkScheduleExitConfirmation:
      "¿Está seguro de salir de este formulario?",
    editWorkScheduleUpdateSuccess:
      "Los detalles del horario de trabajo se actualizaron exitosamente.",
    editWorkScheduleWeekOffUpdateSuccess:
      "Los detalles del día libre se actualizaron exitosamente.",
    editWorkScheduleTechnicalError:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtalo de nuevo más tarde.",
    editWorkScheduleNoUpdateAccess:
      "Lo sentimos, no tienes derechos de acceso para actualizar los detalles del horario de trabajo.",
    editWorkScheduleUpdateError:
      "Algo salió mal al actualizar los detalles del horario de trabajo. Por favor, inténtalo de nuevo más tarde.",
    editWorkScheduleUpdateErrorAdmin:
      "Algo salió mal al actualizar los detalles del horario de trabajo. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    editWorkScheduleShiftMarginEndTime:
      "La hora de finalización del margen de turno debe ser mayor que la hora de inicio del margen de turno.",
    editWorkScheduleShiftMargin24Hours:
      "La hora de inicio y finalización del margen de turno no debe exceder las 24 horas.",
    editWorkScheduleAttendanceExists:
      "No se puede actualizar el horario de trabajo ya que existe asistencia para los empleados asociados con este horario de trabajo.",
    editWorkScheduleShiftScheduled:
      "No se puede actualizar el horario de trabajo ya que el turno está programado para el tipo de turno asociado con este horario de trabajo.",
    editWorkScheduleNoWeekOffAccess:
      "Lo sentimos, no tienes derechos de acceso para agregar detalles de días libres.",
    editWorkScheduleWeekOffUpdateError:
      "Algo salió mal al actualizar los detalles del día libre. Por favor, inténtalo de nuevo más tarde.",
    editWorkScheduleWeekOffUpdateErrorAdmin:
      "Algo salió mal al actualizar los detalles del día libre. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    editWorkScheduleWeekOffAttendanceExists:
      "No se pueden actualizar los detalles del día libre ya que existe asistencia para el empleado asociado con este horario de trabajo",
    editWorkScheduleWeekOffShiftScheduled:
      "No se pueden actualizar los detalles del día libre ya que el turno está programado para el tipo de turno asociado con este horario de trabajo.",
    addWorkScheduleNew: "Nuevo",
    addWorkScheduleAddSuccess:
      "Los detalles del horario de trabajo se agregaron exitosamente.",
    addWorkScheduleWeekOffUpdateSuccess:
      "Los detalles del día libre se actualizaron exitosamente.",
    addWorkScheduleTechnicalError:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtalo de nuevo más tarde.",
    addWorkScheduleNoAddAccess:
      "Lo sentimos, no tienes derechos de acceso para agregar detalles del horario de trabajo.",
    addWorkScheduleAddError:
      "Algo salió mal al agregar los detalles del horario de trabajo. Por favor, inténtalo de nuevo más tarde.",
    addWorkScheduleAddErrorAdmin:
      "Algo salió mal al agregar los detalles del horario de trabajo. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    addWorkScheduleShiftMarginEndTime:
      "La hora de finalización del margen de turno debe ser mayor que la hora de inicio del margen de turno.",
    addWorkScheduleShiftMargin24Hours:
      "La hora de inicio y finalización del margen de turno no debe exceder las 24 horas.",
    addWorkScheduleAttendanceExists:
      "No se puede actualizar el horario de trabajo ya que existe asistencia para los empleados asociados con este horario de trabajo.",
    addWorkScheduleShiftScheduled:
      "No se puede actualizar el horario de trabajo ya que el turno está programado para el tipo de turno asociado con este horario de trabajo.",
    addWorkScheduleNoWeekOffAccess:
      "Lo sentimos, no tienes derechos de acceso para agregar detalles de días libres.",
    addWorkScheduleWeekOffAddError:
      "Algo salió mal al agregar los detalles del día libre. Por favor, inténtalo de nuevo más tarde.",
    addWorkScheduleWeekOffAddErrorAdmin:
      "Algo salió mal al agregar los detalles del día libre. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    addWorkScheduleWeekOffAttendanceExists:
      "No se pueden agregar los detalles del día libre ya que existe asistencia para el empleado asociado con este horario de trabajo",
    addWorkScheduleWeekOffShiftScheduled:
      "No se pueden actualizar los detalles del día libre ya que el turno está programado para el tipo de turno asociado con este horario de trabajo.",
    addEditWorkScheduleTitle: "Horario de Trabajo",
    addEditWorkScheduleOverlappingDays: "Días Superpuestos",
    addEditWorkScheduleOverlappingDaysTooltip:
      "Al habilitar esta opción se superpondrán dos días, es decir (21:00 a 4:00). Y esto se puede habilitar en el caso de turnos nocturnos.",
    addEditWorkScheduleBusinessHours: "Horario Comercial",
    addEditWorkScheduleCheckIn: "Entrada",
    addEditWorkScheduleCheckOut: "Salida",
    addEditWorkSchedulePerSchedule: "por horario",
    addEditWorkScheduleBreakSchedule: "Horario de Descanso",
    addEditWorkScheduleStartTime: "Hora de Inicio",
    addEditWorkScheduleEndTime: "Hora de Fin",
    addEditWorkScheduleShiftMargin: "Margen de Turno",
    addEditWorkScheduleBeforeShiftStarts: "antes de que comience el turno",
    addEditWorkScheduleAfterShiftEnds: "después de que termine el turno",
    addEditWorkScheduleHours: "horas",
    addEditWorkScheduleMinutes: "minutos",
    addEditWorkSchedulePayableHoursNote:
      "Las entradas de entrada/salida solo dentro de {start} a {end} se consideran como horas pagables.",
    addEditWorkScheduleTimezone: "Zona Horaria",
    addEditWorkScheduleTargetEffort: "Esfuerzo Objetivo en Horas (Por Semana)",
    addEditWorkScheduleRegularHours: "Horas Regulares (Por Día)",
    addEditWorkScheduleOvertimeHours: "Horas Extra (Por Día)",
    addEditWorkScheduleStatus: "Estado",
    addEditWorkScheduleAdditionalSettings: "Configuraciones Adicionales",
    addEditWorkScheduleOvertimeCoolingPeriod:
      "Período de Enfriamiento de Horas Extra",
    addEditWorkScheduleOvertimeCoolingPeriodTooltip:
      "Las horas extra comienzan después de este período",
    addEditWorkScheduleAllowAttendanceOutside:
      "Permitir Asistencia Fuera del Horario Regular",
    addEditWorkScheduleAllowAttendanceOutsideTooltip:
      "Al habilitar esta opción, el usuario podrá agregar la asistencia fuera del horario regular pero dentro del margen de turno.",
    addEditWorkScheduleEarlyCheckInOverride: "Anulación de Entrada Temprana",
    addEditWorkScheduleEarlyCheckInOverrideTooltip:
      "Al habilitar esta opción, se considerará la hora de inicio del horario de trabajo incluso si el empleado ha reportado temprano.",
    addEditWorkScheduleEnableGraceTime: "Habilitar Tiempo de Gracia",
    addEditWorkScheduleEnableGraceTimeTooltip:
      "Al habilitar esta opción, los empleados podrán ajustar su hora de entrada según la duración configurada en relación con el horario de trabajo.",
    addEditWorkScheduleGracePeriod: "Período de Gracia para Entrada",
    addEditWorkScheduleCheckOutBufferTime: "Tiempo de Búfer de Salida",
    addEditWorkScheduleCheckOutBufferTimeTooltip:
      "Si la hora de salida excede (Horas de Trabajo Hasta + Tiempo de Búfer de Salida), entonces se considera la salida del horario de trabajo para la asistencia de salida.",
    addEditWorkScheduleDescription: "Descripción",
    addEditWorkScheduleShiftMarginError:
      "Por favor, ajuste las horas del margen de turno para asegurar que la duración total incluyendo el margen de turno sea de 24 horas",
    addEditWorkScheduleActive: "Activo",
    addEditWorkScheduleInActive: "Inactivo",
    employeeType: "Tipo de Empleado",
    grades: "Grados",
    locations: "Ubicaciones",
    departmentHierarchy: "Jerarquía de Departamentos",
    designationsPositions: "Designaciones/Posiciones",
    jobRoles: "Roles de Trabajo",
    businessUnitCostCenter: "Unidad de Negocio / Centro de Costos",
    organizationGroup: "Grupo de Organización",
    locationType: "Tipo de Ubicación",
    locationArea: "Área de Ubicación",
    jobLevels: "Niveles de Trabajo",
    positionDetails: "Detalles de Posición",
    brand: "Marca",
    client: "Cliente",
    errorLoadingForms:
      "Algo salió mal al cargar los formularios de recursos humanos. Por favor, inténtalo de nuevo más tarde.",
    userAccounts: "Cuentas de Usuario",
    customGroup: "Grupo Personalizado",
    projects: "Proyectos",
    holidays: "Días Festivos",
    documentSubtype: "Subtipo de Documento",
    accreditationCategoryAndType: "Categoría y Tipo de Acreditación",
    registerFace: "Registrar Rostro",
    customGroupLoadingError:
      "Algo salió mal al cargar el formulario del grupo. Por favor, inténtalo de nuevo más tarde.",
    customGroupNoRecords: "No se encontraron registros",
    customGroupAddGroup: "Agregar Grupo",
    customGroupViewDeleted:
      "No se pueden recuperar los detalles del grupo personalizado ya que fue eliminado en la misma u otra sesión de usuario.",
    customGroupUpdateDeleted:
      "No se puede actualizar el grupo personalizado ya que fue eliminado en la misma u otra sesión de usuario.",
    customGroupDeleteDeleted:
      "No se puede eliminar el grupo personalizado ya que fue eliminado en la misma u otra sesión de usuario.",
    customGroupTechnicalError:
      "¡Somos nosotros! Parece que hay algunos problemas técnicos. Por favor, inténtalo de nuevo más tarde.",
    customGroupRetrieveError:
      "Algo salió mal al recuperar los grupos personalizados. Por favor, inténtalo de nuevo más tarde.",
    customGroupFetchErrorAdmin:
      "Algo salió mal al obtener los grupos personalizados. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    customGroupFetchError:
      "Algo salió mal al obtener los grupos personalizados. Por favor, inténtalo de nuevo más tarde.",
    customGroupRetrieveErrorFilters:
      "Algo salió mal al recuperar los filtros del grupo personalizado. Por favor, inténtalo de nuevo más tarde.",
    customGroupAddAccessDenied:
      "Lo sentimos, no tienes derechos de acceso para crear grupos personalizados.",
    customGroupEdit: "Editar",
    customGroupNew: "Nuevo",
    customGroupSave: "Guardar",
    customGroupNoChanges: "No hay cambios para actualizar",
    customGroupLabel: "Grupo Personalizado",
    customGroupConfigureFor: "Configurar Para",
    customGroupEmployees: "Empleados",
    customGroupRules: "Reglas",
    customGroupDescription: "Descripción",
    customGroupBack: "Atrás",
    customGroupSelect: "Seleccionar",
    customGroupAdd: "Agregar",
    customGroupNoEmployees: "No hay empleados para listar",
    customGroupEmployeesRequired: "Se requieren empleados",
    customGroupAddSuccess: "Grupo personalizado agregado exitosamente.",
    customGroupUpdateSuccess: "Grupo personalizado actualizado exitosamente.",
    customGroupUpdateWithEmployeesSuccess:
      "Grupo personalizado actualizado y empleados adicionales agregados exitosamente",
    customGroupExitConfirmation:
      "¿Estás seguro de que deseas salir de este formulario?",
    customGroupUpdateAccessDenied:
      "Lo sentimos, no tienes derechos para actualizar grupos personalizados.",
    customGroupNoRecordExist: "No se encontraron registros",
    customGroupValidationError:
      "Algo salió mal al validar las entradas al actualizar el grupo personalizado. Por favor, inténtalo de nuevo más tarde",
    customGroupUpdateSuccessWithLeaveError:
      "Grupo personalizado actualizado exitosamente. Pero no se pudo actualizar el saldo de licencias. Por favor, contacta al administrador del sistema.",
    customGroupUpdateError:
      "Algo salió mal al procesar la solicitud para actualizar el grupo personalizado. Por favor, inténtalo de nuevo más tarde.",
    customGroupUpdateErrorAdmin:
      "Algo salió mal al actualizar el grupo personalizado. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    customGroupCreateError:
      "Algo salió mal al crear el grupo personalizado. Por favor, inténtalo de nuevo más tarde.",
    customGroupCreateErrorAdmin:
      "Algo salió mal al crear el grupo personalizado. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    customGroupCreateErrorProcessing:
      "Algo salió mal al procesar la solicitud para crear el grupo personalizado. Por favor, inténtalo de nuevo más tarde.",
    noEmployeesMatchFilter:
      "No hay empleados que coincidan con sus reglas de filtro",
    startAddingEmployees: "Comience a agregar empleados a este grupo",
    noEmployeesExcluded: "No hay empleados excluidos de este grupo",
    tryChanging: "¿Quieres intentar cambiarlo?",
    search: "Buscar",
    employeeId: "ID de Empleado",
    employeeName: "Nombre del Empleado",
    designation: "Designación",
    department: "Departamento",
    action: "Acción",
    remove: "Eliminar",
    include: "Incluir",
    exclude: "Excluir",
    noEmployeesToList: "No hay empleados para listar.",
    noEmployeesMatchSearch: "No hay empleados que coincidan con su búsqueda",
    selectAll: "Seleccionar Todo",
    includeConfirmation: "¿Está seguro de que desea incluir al empleado?",
    removeConfirmation: "¿Está seguro de que desea eliminar al empleado?",
    excludeConfirmation: "¿Está seguro de que desea excluir al empleado?",
    addNew: "Agregar Nuevo",
    sorryCouldntFind: "¡Lo siento! No se pudo encontrar un grupo que buscaste.",
    configuredFor: "Configurado Para",
    configurationExist: "Existe Configuración",
    rule: "Regla",
    employees: "Empleados",
    additionalEmployees: "Empleados Adicionales",
    employeeExclusion: "Exclusión de Empleados",
    inclusionsExclusions: "Inclusiones y Exclusiones",
    view: "Ver",
    export: "Exportar",
    noDeleteAccessCustomGroup:
      "Lo siento, no tienes acceso para eliminar el grupo personalizado.",
    configurationExists:
      "El grupo personalizado ya se está utilizando para definir las reglas comerciales, por lo que no se permite la eliminación. Puede crear un nuevo grupo personalizado y configurarlo.",
    deleteConfirmationCustomGroup: "¿Está seguro de que desea eliminar?",
    noEmployeesToListInclude:
      "No hay empleados para listar para incluir empleados adicionales",
    noEmployeesToListExclude:
      "No hay empleados para listar para excluir los empleados",
    retrieveError:
      "Algo salió mal al recuperar los empleados. Por favor, inténtalo de nuevo más tarde.",
    employeesExcluded: "Empleado(s) excluido(s) exitosamente",
    employeesIncluded: "Empleado(s) incluido(s) exitosamente",
    deleteSuccessCustomGroup: "El grupo personalizado se eliminó exitosamente.",
    technicalDifficulties:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtalo de nuevo más tarde.",
    noDeleteAccessHR:
      "Lo siento, no tienes acceso para eliminar el grupo personalizado. Por favor, contacta al administrador de RRHH.",
    groupAssociated:
      "No se puede eliminar el grupo personalizado ya que estaba asociado con otros formularios.",
    deleteErrorCustomGroup:
      "Algo salió mal al procesar la solicitud para eliminar el grupo personalizado. Por favor, inténtalo de nuevo más tarde.",
    deleteErrorAdminCustomGroup:
      "Algo salió mal al eliminar el grupo personalizado. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    edit: "Editar",
    back: "Atrás",
    addRule: "Agregar Regla",
    moreDetails: "Más Detalles",
    changeFilter: "Cambiar Filtro",
    add: "Agregar",
    exitConfirmation: "¿Está seguro de salir de este formulario?",
    employeesRemoved: "Empleado(s) eliminado(s) exitosamente",
    noFormAccess:
      "Lo sentimos, no tienes acceso para ver los detalles del grupo personalizado. Por favor, contacta al administrador de RRHH.",
    noRecordExist: "No se encontraron registros",
    retrieveErrorAdmin:
      "Algo salió mal al recuperar los detalles del grupo personalizado. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
  },
};
